import { NAVIGATION } from '../actions';

const initialState = {
    navbarCategory: [
        {
            categoryNameTh: 'หน้าแรก',
            categoryNameEn: 'Home'
        }
    ]
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case NAVIGATION.GET_NAVBAR_CATEGORY_SUCCESS:
            return { ...state, navbarCategory: payload };

        default:
            return state;
    }
};
